import { render, staticRenderFns } from "./TachographSvg.vue?vue&type=template&id=8fce4c7c&"
import script from "./TachographSvg.vue?vue&type=script&lang=js&"
export * from "./TachographSvg.vue?vue&type=script&lang=js&"
import style0 from "./TachographSvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports